import { render, staticRenderFns } from "./category-card.vue?vue&type=template&id=68369750&scoped=true"
import script from "./category-card.vue?vue&type=script&lang=js"
export * from "./category-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68369750",
  null
  
)

export default component.exports